import { QUALIFICATION_KEY_TYPE } from "@/shared/model";
import * as z from "zod";
import { EmployeeSummaryModel } from "./EmployeeSummaryModel";
import { ITeamSummaryModel, TeamSummaryModel } from "./TeamSummaryModel";

const schema = z.object({
	teamSummaryDtos: z.array(TeamSummaryModel.model).default([]),
	employeeSummaryDtos: z.array(EmployeeSummaryModel.model).default([])
});

const model = schema.transform((values) => ({
	...values,
	get teamSummaryMap() {
		return values.teamSummaryDtos.reduce(
			(acc, item) => {
				const salesSummaryType = item.salesSummaryType;

				if (acc[salesSummaryType]) {
					acc[salesSummaryType].push(item);
				} else {
					acc[salesSummaryType] = [item];
				}

				return acc;
			},
			{} as Record<string, ITeamSummaryModel[]>
		);
	},
	get employeeSummaryMap() {
		const monthlyDataMap = new Map<number, typeof values.employeeSummaryDtos[0]>();

		values.employeeSummaryDtos.forEach(item => {
			const month = new Date(item.yearMonth).getMonth(); // 0-11
			monthlyDataMap.set(month, item);
		});

		// 모든 QUALIFICATION_KEY_TYPE에 대한 초기 배열 생성
		const result: Record<QUALIFICATION_KEY_TYPE, number[]> = {
			SETTLEMENT_FEE: [],
			NORMAL_INSURANCE: [],
			TAX_ACCOUNTANT_REGISTRATION: [],
			MANAGER_RECRUITING: []
		};

		// 12개월(0-11)을 순회하며 데이터 채우기
		for (let month = 0; month < 12; month++) {
			const monthData = monthlyDataMap.get(month);

			if (monthData) {
				// 데이터가 있는 경우: 각 salesSummaryType별로 actual 값 추가
				monthData.summaries.forEach(summary => {
					const salesSummaryType = summary.salesSummaryType;
					result[salesSummaryType].push(summary.actual);
				});
			} else {
				// 데이터가 없는 경우: 모든 타입에 0 추가
				result.SETTLEMENT_FEE.push(0);
				result.NORMAL_INSURANCE.push(0);
				result.TAX_ACCOUNTANT_REGISTRATION.push(0);
				result.MANAGER_RECRUITING.push(0);
			}
		}

		return result;
	}
}));

export const SalesSummaryResV2Model = { schema, model };
export type ISalesSummaryResV2Model = z.infer<typeof SalesSummaryResV2Model.model>;
export const DEFAULT_SALES_SUMMARY_RES: ISalesSummaryResV2Model = {
	teamSummaryDtos: [],
	employeeSummaryDtos: [],
	teamSummaryMap: {},
	employeeSummaryMap: {
		SETTLEMENT_FEE: [],
		NORMAL_INSURANCE: [],
		TAX_ACCOUNTANT_REGISTRATION: [],
		MANAGER_RECRUITING: []
	}
};
